import { JSONAPIAdapter } from '@warp-drive/legacy/adapter/json-api';
import { camelize, pluralize } from '@warp-drive/utilities/string';

export default class extends JSONAPIAdapter {
  pathForType(type: string): string {
    // Convert kebab-case type names (e.g., 'media-image') to camelCase plural for API URLs
    // 'media-image' -> 'mediaImages'
    const camelized = camelize(type);
    return pluralize(camelized);
  }
}
